import { IconButton } from '@mui/material';
import { Button } from '@portals/core/src/components/Button/Button';
import { Heart } from '@portals/core-immobilien/src/icons';
import { usePathname } from 'next/navigation';
import router from 'next/router';
import { useTranslation } from 'next-i18next';
import React, { useCallback } from 'react';

import { theme } from '../../themes/immobilien/main';

const activeStyle = {
  backgroundColor: theme.palette.red.main,
  color: 'white',
  display: { lg: 'none' },
};

export const WatchlistButton = () => {
  const { t } = useTranslation();
  const pathname = usePathname();
  const destinationPath = '/immobilien/merkzettel';

  const isActive = pathname === destinationPath;

  const goToWatchlist = useCallback(async () => {
    if (!isActive) {
      await router.push(destinationPath);
    }
  }, []);

  return (
    <>
      <Button
        onClick={goToWatchlist}
        aria-current={isActive ? 'location' : null}
        sx={{ display: { xs: 'none', lg: 'inline-flex' } }}
        startIcon={<Heart />}
      >
        {t('watchlist.headerButton')}
      </Button>
      <IconButton onClick={goToWatchlist} sx={isActive ? activeStyle : { display: { lg: 'none' } }}>
        <Heart />
      </IconButton>
    </>
  );
};
export default WatchlistButton;
